export default "__VITE_ASSET__DFBdFE21__"